/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_TracksInputs */



/**
* | output |
* | --- |
* | "Output audio tracks" |
*
* @param {Audio_Embed_Export_Output_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_tracks = /** @type {((inputs?: Audio_Embed_Export_Output_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pistes audio de sortie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audioausgabespuren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tracce audio in uscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выходные аудиодорожки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pistas de audio de salida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输出音频轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出力オーディオトラック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आउटपुट ऑडियो ट्रैक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faixas de áudio de saída")
	return /** @type {LocalizedString} */ ("Output audio tracks")
});